import { Collapse, Checkbox, CollapseItem, Upload, DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import VueTimepicker from 'vue2-timepicker';
import { Switch as LSwitch } from '@/components/index';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();
import store from '@/services/store';

export default {
    name: 'dashboardRaceRegistrations',
    props: ['userId'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [VueTimepicker.name]: VueTimepicker,
        [Checkbox.name]: Checkbox,
        [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button, [Popover.name]: Popover, LSwitch,
    },
    data() {
        return {
            loadedUserId: 0,
            transferId: null,
            isProcessing: false,
            errorMessage: null,
            tableData: [],
            years: [],
            selectedYear: 0,
            user: null,
            logo: require("../../../../../../images/logo.png"),


            isEverDoneTriathlon: false,
            isAcceptedTerms: false,
            whereHear: '',
            whatSchool: '',
            medicalAnswer: '',
            extraAnswer: '',
            askSwimTIme: '00:00:00',
            askBikeTime: '00:00:00',
            askRunTime: '00:00:00',
            isUserHasPaidLicence: false
        };
    },
    computed: {
        races() {
            var self = this;
            if (!self.tableData) {
                return []
            }
            var data = self.tableData.filter(x => {
                return x.year == self.selectedYear;
            });

            if (data && data.length) {
                return data[0].races;
            }
            return [];
        },
        isValidTransferId() {
            if (this.transferId && this.transferId.indexOf(" ") > -1) {
                this.transferId = this.transferId.split(" ").join("");
            }

            return !isNaN(this.transferId) && this.transferId && this.transferId.length > 6;
        },
        userTransferId() {
            if (this.isValidTransferId) {
                return Number(this.transferId) + 100000 - 10000000
            }
            return null;
        },
        isValidSwimTIme() {
            return this.askSwimTIme != null
                && this.askSwimTIme.length
                && this.askSwimTIme != '00:00:00'
                && isNaN(this.askSwimTIme.split(':'))
                && !this.askSwimTIme.includes('HH')
                && !this.askSwimTIme.includes('mm')
                && !this.askSwimTIme.includes('ss');
        },
        isValidRunTIme() {
            return this.askRunTime != null
                && this.askRunTime.length
                && this.askRunTime != '00:00:00'
                && isNaN(this.askRunTime.split(':'))
                && !this.askRunTime.includes('HH')
                && !this.askRunTime.includes('mm')
                && !this.askRunTime.includes('ss');
        },
        isValidBikeTIme() {
            return this.askBikeTime != null
                && this.askBikeTime.length
                && this.askBikeTime != '00:00:00'
                && isNaN(this.askBikeTime.split(':'))
                && !this.askBikeTime.includes('HH')
                && !this.askBikeTime.includes('mm')
                && !this.askBikeTime.includes('ss');
        },
        isValidWhatSchool() {
            if (this.whatSchool && this.whatSchool.length) {
                return true;
            } else { return false; }
        },
        isValidWhereHear() {
            if (this.whereHear && this.whereHear.length) {
                return true;
            } else { return false; }
        },
        isValidMedicalAnswer() {
            if (this.medicalAnswer && this.medicalAnswer.length) {
                return true;
            } else { return false; }
        },
    },
    methods: {
        odmLink(rId) {
            if (this.userId) {
                return window.location.origin + '/race-odl?rId=' + rId + '&userId=' + this.userId;
            }
            else {
                return window.location.origin + '/race-odl?rId=' + rId;
            }
        },
        acceptTransfer(item) {
            let self = this;
            if (!self.isValidInput(item)) {
                self.$showError("Please fill in required fields.");
                return;
            }

            let model = {
                userId: self.user.userId,
                raceId: item.raceId,
                raceOpeningId: item.raceOpeningId,
                currentRaceRegistrationId: item.id,
                everDoneTriathlon: self.isEverDoneTriathlon,
                whereHear: self.whereHear,
                whatSchool: self.whatSchool,
                extraInfo: self.extraAnswer,
                healthIssues: self.medicalAnswer,
                estimatedRunTime: self.askRunTime,
                estimatedSwimTime: self.askSwimTIme,
                estimatedBikeTime: self.askBikeTime
            };

            svc.postAcceptRaceTransfer(model)
                .then(response => {
                    if (response && response.body && response.body && response.body.isSuccess) {
                        self.$showSuccess("Operation sucsess");
                        self.$router.go();
                    } else {
                        self.$showError();
                    }
                },
                    err => {
                        self.$showError();
                    });
        },
        cancelTransfer(item) {
            let self = this;
            if (confirm('Are you sure you want to cancel race transfer?')) {
                svc.cancelRaceTransfer(item.id)
                    .then(response => {
                        if (response && response.body && response.body && response.body.isSuccess) {
                            self.$showSuccess("Operation sucsess");
                            self.$router.push({ path: '/' });
                        } else {
                            self.$showError();
                        }
                    },
                        err => {
                            self.$showError();
                        });
            }
        },
        isValidInput(item) {
            let validArray = [];
            if (item.askWhatSchool) {
                validArray.push(this.isValidWhatSchool);
            }
            if (item.askWhereHear) {
                validArray.push(this.isValidWhereHear);
            }
            if (item.askBikeTime) {
                validArray.push(this.isValidBikeTime);
            }
            if (item.askSwimTime) {
                validArray.push(this.isValidSwimTime);
            }
            if (item.askRunTime) {
                validArray.push(this.isValidRunTime);
            }

            validArray.push(this.isValidMedicalAnswer);
            validArray.push(this.isAcceptedTerms);
            if (validArray.some(x => x == false)) {
                return false;
            }
            else { return true; }
        },
        setUser() {
            this.user = store.getters.getCurrentUserShortInfo;
            if (this.user && this.user.details && !this.user.details.isAdult) {
                var parent = store.getters.getUserShortInfo;
                this.user.details.email = parent.details.email;
                this.user.details.phone = parent.details.phone;
            }
            else {
                this.user = store.getters.getUserShortInfo;
            }
            this.$console(this.user);
        },
        getData() {
            var self = this;
            self.isProcessing = true;

            if (self.userId < -2) {
                return;
            }

            if (self.userId && (self.loadedUserId < -2 || self.loadedUserId == 0)) {
                self.loadedUserId = self.userId;
            }

            if (self.userId != -1) {
                EventBus.$emit("user-load-dashboard-card", self.loadedUserId);
            }
            var data = { userId: self.loadedUserId };
            svc.getRacesTransfersRegistrations(data).then(response => {
                var allData = response.body;
                self.isProcessing = false;
                if (!allData) {
                    self.errorMessage = "Something went wrong!";
                    return;
                }
                if (!allData.isSuccess) {
                    self.errorMessage = "USER DOES NOT HAVE ANY TRANSFERRED RACE REGISTRATIONS!";
                    return;
                }
                else {
                    self.errorMessage = null;
                    self.tableData = allData.raceByYears;
                    self.years = allData.years;
                    self.isUserHasPaidLicence = allData.isUserHasPaidLicence;
                    if (self.years && self.years.length) {
                        self.selectedYear = self.years[0];
                    }
                }

                self.$console();
                self.$console({ races: self.tableData });

                if (!self.user) {
                    self.setUser();
                }

                return self.tableData;
            }, () => {
                self.isProcessing = false;
                self.errorMessage = "Something went wrong, please contact with dev team!";
            });
        }
    },
    created() {
        var self = this;
        self.getData();
        EventBus.$off('user-load-race-registrations');
        EventBus.$on("user-load-race-registrations", (id) => {
            self.loadedUserId = id;
            self.getData();
        });

        EventBus.$off('view-race-ragistration-load-user');
        EventBus.$on('view-race-ragistration-load-user', () => {
            self.setUser();
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/transfer-registration/transfer-registration.js